import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const MenuIconMobile = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 28}
        height={size ?? 28}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.49998 9.33333H24.5C25.2 9.33333 25.6666 8.86667 25.6666 8.16667C25.6666 7.46667 25.2 7 24.5 7H3.49998C2.79998 7 2.33331 7.46667 2.33331 8.16667C2.33331 8.86667 2.79998 9.33333 3.49998 9.33333ZM15.1666 18.6667H3.49998C2.79998 18.6667 2.33331 19.1333 2.33331 19.8333C2.33331 20.5333 2.79998 21 3.49998 21H15.1666C15.8666 21 16.3333 20.5333 16.3333 19.8333C16.3333 19.1333 15.8666 18.6667 15.1666 18.6667ZM24.5 12.8333H3.49998C2.79998 12.8333 2.33331 13.3 2.33331 14C2.33331 14.7 2.79998 15.1667 3.49998 15.1667H24.5C25.2 15.1667 25.6666 14.7 25.6666 14C25.6666 13.3 25.2 12.8333 24.5 12.8333Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default MenuIconMobile;
